import CssBaseline from "@mui/material/CssBaseline";
import AppTheme from "../theme/AppTheme";
import AppAppBar from "../components/AppAppBar";
import Footer from "../components/Footer";
import ContactSection from "../components/Contact";

export default function Contact(props: { disableCustomTheme?: boolean }) {
  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />

      <AppAppBar />
      <div>
        <ContactSection />
        <Footer />
      </div>
    </AppTheme>
  );
}
